export const getSubmitRequestStatus = state => state.submitRequestStatus;

export const getSchedulingLink = state => state.schedulingLink;
export const getCaseNumber = state => state.caseNumber;

